/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{padding:.4166666667em 0}[_nghost-%COMP%]  .mat-radio-container{height:12px;width:12px}[_nghost-%COMP%]  .mat-radio-outer-circle{height:12px;width:12px}[_nghost-%COMP%]  .mat-radio-inner-circle{height:12px;width:12px}[_nghost-%COMP%]  .mat-radio-button .mat-radio-ripple{height:24px;width:24px;left:calc(50% - 12px);top:calc(50% - 12px)}[space-between][_nghost-%COMP%]   .form-inline-radio[_ngcontent-%COMP%]{width:100%;display:flex;justify-content:flex-end}"];
export { styles as styles };
